const de = require('./de.json')
const en = require('./en.json')
const es = require('./es.json')
const fi = require('./fi.json')
const fr = require('./fr.json')
const nl = require('./nl.json')
const pl = require('./pl.json')
const pt = require('./pt.json')
const ru = require('./ru.json')
const sv = require('./sv.json')
const it = require('./it.json')

export {
    de, en, es, fi, fr, nl, pl, pt, ru, sv, it
}